import styled from "styled-components";

export const HiddenSpan = styled.span`
  ${(props: { hidden?: boolean }) =>
    props.hidden ? `visibility: hidden;` : ``};
`;
HiddenSpan.displayName = "HiddenSpan";
